import React, { FC } from 'react';
import { useParams } from 'react-router';

import { useGetRequestWorkShortInfoQuery } from 'bus/request';

const DetailTaskInfo: FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data } = useGetRequestWorkShortInfoQuery({ id });

  return (
    <div className="d-flex">
      <div className="dx-card pl-2 pr-2 pb-2 mb-3 mr-2" style={{ width: 750 }}>
        <div className="info">
          <div className="info__title">Поставщик</div>
          <div className="info__child">{data?.provider}</div>
        </div>
        <div className="info">
          <div className="info__title">Номенклатура</div>
          <div className="info__child">{data?.nomenclature}</div>
        </div>
      </div>
      <div className="dx-card pl-2 pr-2 pb-2 mb-3" style={{ width: '100%' }}>
        <div className="info">
          <div className="info__title">Заказчик</div>
          <div className="info__child">{data?.contractor}</div>
        </div>
        <div className="info">
          <div className="info__title">Адрес</div>
          <div className="info__child">{data?.objectAddress}</div>
        </div>
      </div>
    </div>
  );
};

export default DetailTaskInfo;
